import {
  TCsvQuoteCharacterTranslations,
} from './select-csv-quote-char.ts';

const translations: TCsvQuoteCharacterTranslations = {
  single_quote: 'Pojedynczy cytat',
  double_quote: 'Podwójny cudzysłów',
};

export default {
  placeholder: 'Proszę wybrać styl cytowania',
  exampleText: 'mój tekst',
  label: 'Cytat postaci',
  options: translations,
};
